var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895",
    transform: "translate(-369 -274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_file_black_24dp",
    transform: "translate(484 274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8298",
    "data-name": "Path 8298",
    d: "M0,0H96.673V96.673H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8299",
    "data-name": "Path 8299",
    d: "M44.28,2H12.056A8.045,8.045,0,0,0,4.04,10.056L4,74.5a8.045,8.045,0,0,0,8.016,8.056H60.392A8.08,8.08,0,0,0,68.449,74.5V26.168ZM60.392,74.5H12.056V10.056h28.2V30.2h20.14ZM20.112,54.4l5.68,5.68,6.4-6.364V70.477h8.056V53.72l6.4,6.4,5.68-5.72L36.265,38.252Z",
    transform: "translate(12.112 6.056)",
    fill: "#aaa"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Drag_and_drop_documents_here",
    "data-name": "Drag and drop documents here",
    transform: "translate(369 410)",
    fill: "#aaa",
    fontSize: 24,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Drag and drop documents here")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.22ffe74168afd2bb1977115bb6de3cea.svg";
export { ForwardRef as ReactComponent };